app.controller('studentLoginCtrl', [
    '$scope', '$state', 'authService', 'freeGameService', 'keyboardService', function ($scope, $state, authService, freeGameService, keyboardService) {
        var vm = this;

        vm.keyboardShown = keyboardService.isShown;
        $scope.$on('keyboardShownChanged', function(event, args) {
            $scope.$apply(function() {
                vm.keyboardShown = args.shown;
            });
        });

        vm.loggingIn = false;

        vm.pin1 = "";
        vm.pin2 = "";
        vm.pin3 = "";
        vm.pin4 = "";

        vm.resetPin = function() {
            vm.pin1 = "";
            vm.pin2 = "";
            vm.pin3 = "";
            vm.pin4 = "";
        }

        vm.pin1change = function() {
            if (vm.pin1.length > 0) {
                angular.element("#pin2").focus();
            }
        }

        vm.pin1keydown = function(evt) {
        }

        vm.pin2change = function() {
            if (vm.pin2.length > 0) {
                angular.element("#pin3").focus();
            } else {
                angular.element("#pin1").focus();
            }
        }

        vm.pin2keydown = function(evt) {
            if (evt.keyCode === 8 && vm.pin2.length === 0) {
                angular.element("#pin1").focus();
            }
        }

        vm.pin3change = function() {
            if (vm.pin3.length > 0) {
                angular.element("#pin4").focus();
            } else {
                angular.element("#pin2").focus();
            }
        }

        vm.pin3keydown = function(evt) {
            if (evt.keyCode === 8 && vm.pin3.length === 0) {
                angular.element("#pin2").focus();
            }
        }

        vm.pin4change = function() {
            if (vm.pin4.length <= 0) {
                angular.element("#pin3").focus();
            }
        }

        vm.pin4keydown = function(evt) {
            if (evt.keyCode === 8 && vm.pin4.length === 0) {
                angular.element("#pin3").focus();
            }
        }

        vm.error = false;
        vm.login = function() {
            vm.error = false;
            var pin = "" + vm.pin1 + vm.pin2 + vm.pin3 + vm.pin4;
            vm.loggingIn = true;
            authService.authenticateWithPin(pin).then(function(authStatus) {
                vm.loggingIn = false;

                if (authStatus === true) {
                    if (authService.isTeacher) {
                        $state.go('teacherapp.welcome');
                    } else {
                        $state.go('student.welcome');
                    }
                } else {
                    vm.error = true;
                    vm.resetPin();
                }
            }, function(err) {
                vm.loggingIn = false;
                vm.error = true;
                vm.resetPin();
            });
        }

        vm.goFreeGame = function() {
            $state.go('student.freegameperform', {id: 0, question: 0});
        }
   }
]);